import BaseAPI from '../base'

function getById(id) {
    return BaseAPI.sendGet(`currency/info/${id}`);
}

export default {
    getById
}